import { render, staticRenderFns } from "./product-price.vue?vue&type=template&id=fa7dabfc&scoped=true"
import script from "./product-price.vue?vue&type=script&lang=js"
export * from "./product-price.vue?vue&type=script&lang=js"
import style0 from "./product-price.vue?vue&type=style&index=0&id=fa7dabfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7dabfc",
  null
  
)

export default component.exports